/* Homepage hero — hierarchical Area multi-select (same UX as listings). */
(function () {
	'use strict';

	var areasWrap = document.getElementById('btr-hero-areas-dropdown');
	var areasToggle = document.getElementById('btr-hero-areas-toggle');
	var areasMenu = document.getElementById('btr-hero-areas-menu');
	if (!areasWrap || !areasToggle || !areasMenu) {
		return;
	}

	var areasLabel = areasToggle.querySelector('.btr-multi-toggle__label');

	function updateAreasLabel() {
		if (!areasLabel) {
			return;
		}
		var checked = areasMenu.querySelectorAll('input[name="areas[]"]:checked');
		var labels = [];
		for (var i = 0; i < checked.length; i++) {
			var span = checked[i].parentNode.querySelector('span');
			if (span) {
				labels.push(span.textContent.replace(/^-\s*/, '').trim());
			}
		}
		if (!labels.length) {
			areasLabel.textContent = 'Select area(s)';
		} else if (labels.length > 2) {
			areasLabel.textContent = labels.slice(0, 2).join(', ') + ' +' + (labels.length - 2);
		} else {
			areasLabel.textContent = labels.join(', ');
		}
	}

	function syncAreaMains() {
		var mains = areasMenu.querySelectorAll('.btr-area-main');
		for (var i = 0; i < mains.length; i++) {
			var group = mains[i].getAttribute('data-group');
			var kids = areasMenu.querySelectorAll('.btr-area-item[data-group="' + group + '"]');
			if (!kids.length) {
				continue;
			}
			var allOn = true;
			for (var k = 0; k < kids.length; k++) {
				if (!kids[k].checked) {
					allOn = false;
					break;
				}
			}
			mains[i].checked = allOn;
			mains[i].indeterminate = !allOn && Array.prototype.some.call(kids, function (el) {
				return el.checked;
			});
		}
	}

	function setAreasOpen(isOpen) {
		areasWrap.classList.toggle('is-open', isOpen);
		areasToggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
		areasMenu.hidden = !isOpen;
	}

	areasWrap.addEventListener('click', function (e) {
		e.stopPropagation();
	});

	areasToggle.addEventListener('click', function (e) {
		e.preventDefault();
		e.stopPropagation();
		setAreasOpen(areasMenu.hidden);
	});

	areasMenu.addEventListener('change', function (e) {
		var target = e.target;
		if (!target || target.type !== 'checkbox') {
			return;
		}
		var group = target.getAttribute('data-group');
		if (target.classList.contains('btr-area-main') && group) {
			var kids = areasMenu.querySelectorAll('.btr-area-item[data-group="' + group + '"]');
			for (var i = 0; i < kids.length; i++) {
				kids[i].checked = target.checked;
			}
			target.indeterminate = false;
		} else if (group) {
			syncAreaMains();
		}
		updateAreasLabel();
	});

	document.addEventListener('click', function () {
		setAreasOpen(false);
	});
	document.addEventListener('keydown', function (e) {
		if (e.key === 'Escape') {
			setAreasOpen(false);
		}
	});

	syncAreaMains();
	updateAreasLabel();
})();
